import { FC } from 'react'
import { Form, FormType } from './form/Form'

export const Control: FC & FormType = (): JSX.Element => <></>

Control.Form = Form
